module.exports = __webpack_public_path__ + "static/connect-0c5ca950fc451d7edda8f4fa2ee61988.svg";